<template>
  <div>
    <!-- HEADER -->
    <div class="d-flex justify-content-between align-items-start">
      <div>
        <h4 class="font-weight-bold">Regulatory Reports</h4>
        <div class="text-muted">
          All regulatory submissions across Australian jurisdictions
        </div>
      </div>

      <div>
        <b-button variant="outline-secondary" class="mr-1">
          <feather-icon icon="CalendarIcon" />
          Schedule
        </b-button>

        <b-button variant="primary">
          <feather-icon icon="SendIcon" />
          Submit All Due
        </b-button>
      </div>
    </div>

    <b-row class="mt-2">
      <b-col
        v-for="(state, index) in states"
        :key="index"
        cols="12"
        md="6"
        xl="4"
        class="mb-2"
      >
        <b-card class="state-card shadow-sm">
          <!-- CARD HEADER -->
          <div class="d-flex justify-content-between align-items-center mb-1">
            <div class="d-flex align-items-center">
              <span
                class="state-badge mr-1"
                :style="{ background: state.color }"
              >
                {{ state.code }}
              </span>
              <strong>{{ state.name }}</strong>
            </div>

            <b-badge :variant="state.statusVariant">
              {{ state.status }}
            </b-badge>
          </div>

          <div v-for="(report, i) in state.reports" :key="i" class="report-row">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <div class="font-weight-semibold">
                  {{ report.title }}
                </div>

                <div class="text-muted small">
                  <span class="status-dot" :class="report.dotColor"></span>
                  {{ report.desc }}
                </div>
              </div>

              <!-- ACTION BUTTONS -->
              <div class="d-flex align-items-center" style="gap: 8px">
                <b-button size="sm" variant="outline-secondary">
                  <feather-icon icon="EyeIcon" size="14" />
                </b-button>

                <b-button size="sm" variant="outline-primary">
                  <feather-icon icon="DownloadIcon" size="14" />
                </b-button>

                <b-button
                  v-if="report.upload"
                  size="sm"
                  variant="outline-secondary"
                >
                  <feather-icon icon="UploadIcon" size="14" />
                </b-button>

                <b-button
                  v-if="report.approve"
                  size="sm"
                  :variant="report.approveVariant"
                >
                  <feather-icon icon="CheckIcon" size="14" />
                </b-button>

                <b-button size="sm" :variant="report.submitVariant">
                  <feather-icon icon="SendIcon" size="14" />
                </b-button>
              </div>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BCard, BButton, BBadge } from "bootstrap-vue";
export default {
  components: { BRow, BCol, BCard, BButton, BBadge },
  data() {
    return {
      states: [
        {
          code: "NSW",
          name: "Racing NSW",
          color: "#dbeafe",
          status: "Up to date",
          statusVariant: "success",
          reports: [
            {
              title: "Daily Betting Report",
              desc: "Auto-submitted daily 6:00 AM",
              dotColor: "dot-success",
              submitVariant: "success",
            },
            {
              title: "Weekly Summary",
              desc: "Due: Sunday 11:59 PM",
              dotColor: "dot-success",
              upload: true,
              approve: true,
              approveVariant: "success",
              submitVariant: "success",
            },
            {
              title: "Monthly Return",
              desc: "Due: 7th of each month",
              dotColor: "dot-warning",
              upload: true,
              approve: true,
              approveVariant: "warning",
              submitVariant: "secondary",
            },
          ],
        },

        {
          code: "QLD",
          name: "Racing Queensland",
          color: "#fde2f3",
          status: "Up to date",
          statusVariant: "success",
          reports: [
            {
              title: "Daily Betting Report",
              desc: "Auto-submitted daily 6:00 AM",
              dotColor: "dot-success",
              submitVariant: "success",
            },
            {
              title: "Monthly Return",
              desc: "Due: 14th of each month",
              dotColor: "dot-warning",
              upload: true,
              approve: true,
              approveVariant: "warning",
              submitVariant: "secondary",
            },
          ],
        },

        {
          code: "VIC",
          name: "Racing Victoria",
          color: "#d1fae5",
          status: "1 pending",
          statusVariant: "warning",
          reports: [
            {
              title: "Daily Betting Report",
              desc: "Auto-submitted daily 6:00 AM",
              dotColor: "dot-success",
              submitVariant: "success",
            },
            {
              title: "Quarterly Compliance",
              desc: "Due: Jan 31, 2026",
              dotColor: "dot-danger",
              approve: true,
              approveVariant: "danger",
              submitVariant: "secondary",
            },
          ],
        },
      ],
    };
  },
};
</script>

<style scoped>
.regulatory-wrapper {
  padding: 24px;
  background: #f8fafc;
}

.state-card {
  border-radius: 12px;
}

.state-badge {
  padding: 6px 10px;
  font-size: 12px;
  border-radius: 6px;
  font-weight: 600;
}

.report-row {
  padding: 14px 0;
  border-top: 1px solid #eee;
}

.report-row:first-of-type {
  border-top: none;
}

.status-dot {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 50%;
}

.dot-success {
  background: #22c55e;
}
.dot-warning {
  background: #f59e0b;
}
.dot-danger {
  background: #ef4444;
}
</style>
